<template>
    <div class="attachment-card" :class="{'attachment-card--in-group': inGroup}" :data-qa="itemId">
        <div class="attachment-card__interaction">
            <button @click.prevent="$emit('subtract-item')" class="" :class="{'opacity-50 cursor-not-allowed': subtractDisabled}" data-qa="subtract-button">
                <MinusIcon class="w-[30px] h-[30px] md:w-[22px] md:h-[22px]"/>
                <span class="sr-only">Subtract</span>
            </button>
            <button @click.prevent="$emit('increment-item')" :class="{'opacity-50 cursor-not-allowed': addDisabled}" data-qa="add-button">
                <PlusIcon class="w-[30px] h-[30px] md:w-[22px] md:h-[22px]"/>
                <span class="sr-only">Add</span>
            </button>
        </div>
        <div class="attachment-card__details">
            <p class="text-base font-medium" data-qa="item-name">{{ quantityText }}</p>
            <p class="text-xs mt-1" v-if="itemDescription" data-qa="item-description">{{ itemDescription }} <Link v-if="learnMore" @click.prevent="$refs.learnMoreModal.openModal()" no-underline css-underline data-qa="learn-more">Learn more</Link></p>
        </div>
        <div class="attachment-card__price">
            <p class="text-lg mb-2 font-sans font-normal leading-none md:leading-none" v-if="!included" data-qa="item-total"><span class="text-xl font-bold"><span v-text="$store.getters.currencyPrefix"></span>{{ priceFormat(itemPricing) }}</span><span v-if="itemType != 'charge'">/{{ billingPeriod }}</span></p>
            <p class="text-lg mb-2 font-sans font-normal leading-none md:leading-none" v-else data-qa="item-total">Included</p>
            <p class="text-s font-medium leading-none" v-if="$store.getters.isYearly && !included">Paid yearly &mdash; <span v-text="$store.getters.currencyPrefix"></span>{{ yearlyPrice }}/yr</p>
        </div>
        <Modal ref="learnMoreModal" v-if="learnMore" :qa-name="`${itemId}_learnMore_modal`">
            <h1 class="text-xl font-bold mb-3">{{ learnMore.title }}</h1>
            <p v-for="paragraph, key in learnMore.content" :key="key" class="mb-4 last:mb-0" v-html="paragraph"></p>
        </Modal>
    </div>
</template>

<script>
import MinusIcon from '@/../svg/Icon_minus.svg?component';
import PlusIcon from '@/../svg/Icon_plus.svg?component';
import Link from '@/Components/Link.vue';
import Modal from '@/Components/Modal.vue';
import { priceFormat } from '@/Util/helpers.js';

export default {
    data() {
        return {
            attachmentChecked: false,
        };
    },
    emits: [
        'subtract-item',
        'increment-item',
    ],
    components: {
        PlusIcon,
        MinusIcon,
        Modal,
        Link,
    },
    props: {
        inGroup: {
            type: Boolean,
            default: false,
        },
        included: {
            type: Boolean,
            default: false,
        },
        subtractDisabled: {
            type: Boolean,
            default: true,
        },
        learnMore: Object,
        addDisabled: {
            type: Boolean,
            default: false,
        },
        quantityText: String,
        itemDescription: {
            type: [String, Boolean],
            default: false,
        },
        itemPricing: [String, Number],
        itemId: String,
        billingPeriod: {
            type: String,
            default: 'mo',
        },
        yearlyPrice: {
            type: [String, Number, Boolean],
            default: false,
        },
        itemType: String,
    },
    methods: {
        priceFormat,
    },
};
</script>

<style lang="postcss" scoped>

.attachment-card {
    @apply border-gray-4 border-2 rounded-medium p-3 flex flex-col md:flex-row gap-4 md:items-start;

    &--in-group {
        @apply md:border-none;
    }

    &__interaction {
        @apply flex-shrink-0 grid grid-cols-2 gap-2.5 self-start mt-1;
    }

    &__details {
        @apply flex-grow;
    }

    &__price {
        @apply flex-shrink-0 self-start text-left md:text-right;
    }
}

.check-mark-enter-active,
.check-mark-leave-active {
    @apply transition-opacity duration-200 ease-in-out;
}

.check-mark-enter-from,
.check-mark-leave-to {
    @apply opacity-0;
}
</style>
